export const isSidePanelAllowed = (state) => {
    if (state.variant === "Arc") {
        return false;
    }
    return true;
};
export const sidePanelExceptionReason = (state) => {
    if (state.variant === "Arc") {
        return "Not available for Arc";
    }
    return null;
};
